import { Box, Typography, styled } from "@mui/material";
import { CustomDisplayItem } from "@/components/custom/custom-display-item";

const Row = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: theme.spacing(3),
  [theme.breakpoints.up("lg")]: { flexDirection: "row" },
}));

const Side = styled(Box)(({ theme }) => ({
  flexShrink: 0,
  [theme.breakpoints.up("lg")]: { width: 256 },
}));

const Grid = styled(Box)(({ theme }) => ({
  flex: 1,
  display: "grid",
  gridTemplateColumns: "1fr",
  gap: theme.spacing(2),
  [theme.breakpoints.up("md")]: { gridTemplateColumns: "1fr 1fr" },
}));

const formatBoolean = (val) => {
  if (val === true) return "Yes";
  if (val === false) return "No";
  return "-";
};

export const CustomerProfileIdentity = ({ data }) => {
  return (
    <Row>
      <Side>
        <Typography fontWeight={500} fontSize={18}>
          Identity & Verification
        </Typography>
        <Typography variant="body2" color="text.secondary">
          KYC and identity verification status.
        </Typography>
      </Side>
      <Grid>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Customer Type" value={data?.customerType} />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Access Type" value={data?.accessType} />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="BVN Validated"
            value={formatBoolean(data?.bvnValidated)}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="NIN Validated"
            value={formatBoolean(data?.ninValidated)}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="Face Liveness"
            value={formatBoolean(data?.facelivenssValidated)}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem
            label="KYC Approval Pending"
            value={formatBoolean(data?.adminKycApprovalPending)}
          />
        </Box>
        <Box sx={{ backgroundColor: "background.paper" }}>
          <CustomDisplayItem label="Merchant ID" value={data?.merchantId} />
        </Box>
      </Grid>
    </Row>
  );
};
